// extracted by mini-css-extract-plugin
module.exports = {"jackpot":"_167df4a","exclusiveIcon":"_4b94fdf"};